import { Component, h, options } from 'preact';

class TcrComboBox extends Component
{
    constructor(props)
    {
        super(props);

        this.setFocus = this.setFocus.bind(this);
        this.blur = this.blur.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onOptionClicked = this.onOptionClicked.bind(this);
        this.onPaste = this.onPaste.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        this.state = {
            ...this.propsToState(props),
            fcount: 0
        };
    }

    componentWillReceiveProps(nextProps)
    {
        this.setState(this.propsToState(nextProps));
    }

    propsToState(props)
    {
        let state = {
            value: props.value,
            input: this.getDisplay(props.value, props.options),
            focus: false
        };
        return state;
    }

    onPaste(event)
    {
        if (typeof this.props.onPaste == 'function')
        {
            return this.props.onPaste(event);
        }
    }

    setFocus(e)
    {
        this.setState(prevState => {
            return {
                fcount: prevState.fcount + 1
            };
        }, this.toggleMenu);
        console.log('focus', e);
    }

    blur(e)
    {
        console.log('blur', e);
        this.setState(prevState => {
            return {
                fcount: prevState.fcount - 1
            };
        }, this.toggleMenu);
    }

    toggleMenu()
    {
        setTimeout(() => {
            this.setState(prevState => {
                return {
                    focus: prevState.fcount > 0
                };
            });
        }, 100);
    }

    onInput(e)
    {
        let input = e.target.value;
        let value = this.getValue(input, this.props.options);
        if (value != '')
        {
            console.log('match value' + value);
            this.props.onInput({ target: { value: value }});
        }
        else
        {
            console.log('onInput', e);
            this.setState({
                input: e.target.value,
                focus: true
            });

        }
    }

    onOptionClicked(value)
    {
        console.log('clicked', value, typeof value);
        this.props.onInput({ target: { value: value }});
    }

    onKeyDown(e)
    {
        //console.log('onKeyDown', e);
        // if (e.keyCode === 38) //up
        // {
        //     e.preventDefault();
        // }
        // else if (e.keyCode === 40) //down
        // {
        //     e.preventDefault();
        // }
        // else if (e.keyCode === 13) //enter
        // {
        //     e.preventDefault();

        // }
    }

    getValue(display, options)
    {
        for (let option of options || [])
        {
            if (option.display == display) return option.value;
        }
        return '';
    }

    getDisplay(value, options)
    {
        for (let option of options || [])
        {
            if (option.value == value) return option.display;
        }
        return '';
    }

    render()
    {
        let options = (this.props.options || []).filter(o => {
            return o.display.toLowerCase().indexOf(this.state.input.toLowerCase()) >= 0;
        })
        options.sort((a,b) => {
            return a.display.localeCompare(b.display,  'de', { sensitivity: 'base' });
        });
        options = options.map(o => {
            return (
                <div class="option" data-value={o.value} onClick={() => this.onOptionClicked(o.value)}>{o.display}</div>
            );
        });
        return (
            <div class="tcr-combo-box">
                <input type="text" value={this.state.input} data-field={this.props.field} onInput={this.onInput} onKeyDown={this.onKeyDown} onFocus={this.setFocus} onBlur={this.blur} onPaste={this.onPaste} />
                <div class="placeholder" data-hide={!!this.state.input}>{this.props.placeholder}</div>
                <div class="menu" tabindex="-1" onFocus={this.setFocus} onBlur={this.blur} data-hide={!this.state.focus}>
                    {options}
                </div>
            </div>
        );
    }
}

export { TcrComboBox };
